"use strict";
/**
 * Проверяет переданное значение на соотвествие null
 * @example
 * isNull(null) // -> true
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.isNull = void 0;
// tslint:disable-next-line:strict-type-predicates
var isNull = function (value) { return value === null; };
exports.isNull = isNull;
//# sourceMappingURL=isNull.js.map